/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IProductSpecificationViewProps } from './product-specification';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = props => {
    const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps, productSpecificationResult } = props;
    return (
        <Module {...ProductSpecification}>
            {props.title}
             <Node {...ProductSpecificationTableProps}>
                <Node {...ProductSpecificationTableBodyProps}>
                    {productSpecificationResult && productSpecificationResult.map((row) => {
                        return row;
                    })}
                 </Node>
            </Node>
        </Module>
    );
};

export default ProductSpecificationView;